import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ITimeTrack, ITimeTrackDto, ITimeTrackFilter } from "./time-track.interface";
import * as _ from 'lodash';
import { HttpService } from "../../../../http.service";
import { UtilsService } from "../../../shared/services/utils.service";
import { apiURL, EnvConfig } from "../../../../env-config";

@Injectable()
export class TimeTrackService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
  ) { }

  getTimeTracks(filter?: ITimeTrackFilter): Observable<ITimeTrackDto[]> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_TASKS)}/timeTrack${queryParams}`);
  }
  
  getTimeTracksGroupByTask(filter?: ITimeTrackFilter): Observable<ITimeTrackDto[]> {
    // filter.apiversion = '2';
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_TIMETRACK)}/groupByTask${queryParams}`);
  }

  getTimeTrack(timetrack: ITimeTrack | string): Observable<any> {
    let id = (typeof timetrack == 'string') ? timetrack : timetrack._id;
    return this._http.get(`${apiURL(EnvConfig.API_TIMETRACK)}/${id}`);
  }

  createTimeTrack(timetrack: any): Observable<any> {
    timetrack.apiversion = '2';
    return this._http.post(`${apiURL(EnvConfig.API_TIMETRACK)}`, timetrack);
  }

  updateTimeTrack(timetrack: ITimeTrack): Observable<any> {
    let id = timetrack._id;
    delete timetrack._id;
    return this._http.patch(`${apiURL(EnvConfig.API_TIMETRACK)}/${id}`, timetrack);
  }

  deleteTimeTrack(timetrack: ITimeTrack | string, hardDelete: boolean = false): Observable<void> {
    let id = (typeof timetrack == 'string') ? timetrack : timetrack._id;
    if (hardDelete) return this._http.delete(`${apiURL(EnvConfig.API_TIMETRACK)}/${id}`);
    return this._http.delete(`${apiURL(EnvConfig.API_TIMETRACK)}/${id}/delete`);
  }

  restoreTimeTrack(timetrack: ITimeTrack | string): Observable<void> {
    let id = (typeof timetrack == 'string') ? timetrack : timetrack._id;
    return this._http.post(`${apiURL(EnvConfig.API_TIMETRACK)}/${id}/restore`, null);
  }
}